<script>
import axios from 'axios';
import get from 'lodash/get';
import each from 'lodash/each';
import Vue from 'vue';
import {ToastProgrammatic as Toast} from 'buefy'

import Account from './domains/account/Account';

Vue.mixin({
    methods: {
        updateState(state, property, value) {
            this.$store.commit('updateState', {state, property, value});
        },
    },
});

export default {
    components: {
        Account,
    },
    data: () => ({
        menuOpen: false,
        menuHeight: null,
    }),
    async created() {
        axios.interceptors.request.use(config => {
            if (this.$store.state.jwt) {
                config.headers['Authorization'] = `Bearer ${this.$store.state.jwt}`;
            }

            return config;
        }, e => {
            throw e;
        });

        axios.interceptors.response.use(res => {
            if (res.headers.jwt_refresh) {
                localStorage.setItem('jwt', res.headers.jwt_refresh);

                this.updateState(this.$store.state, 'jwt', res.headers.jwt_refresh);

                this.$_initLogoHeight();
            }

            return res;
        }, async e => {
            if (e.response.headers.jwt_refresh) {
                localStorage.setItem('jwt', e.response.headers.jwt_refresh);

                this.updateState(this.$store.state, 'jwt', e.response.headers.jwt_refresh);

                this.$_initLogoHeight();
            }

            if (e.response.status === 401) {
                this.logout();
            } else {
                if (get(e, 'response.data.errors')) {
                    each(e.response.data.errors, errors => {
                        each(errors, message => {
                            Toast.open({
                                message,
                                type: 'is-danger',
                            });
                        });
                    });
                } else if (get(e, 'response.data.error')) {
                    Toast.open({
                        message: e.response.data.error,
                        type: 'is-danger',
                    });
                } else if (get(e, 'response.data.message')) {
                    Toast.open({
                        message: e.response.data.message,
                        type: 'is-danger',
                    });
                } else {
                    console.error(e);
                }

                throw e;
            }
        });

        this.$store.dispatch('getEnums');

        try {
            await this.$store.dispatch('getCurrentUser');
        } catch (e) {
            this.logout();
        }

        window.addEventListener('resize', this.$_initLogoHeight);
    },
    mounted() {
        this.$_initLogoHeight();
    },
    destroyed() {
        window.removeEventListener('resize', this.$_initLogoHeight);
    },
    methods: {
        $_initLogoHeight() {
            if (this.$store.state.jwt && this.$refs.logo) {
                this.menuHeight = this.$refs.logo.offsetHeight;
            }
        },
        async logout() {
            this.updateState(this.$store.state, 'jwt', null);

            this.updateState(this.$store.state, 'user', null);

            localStorage.removeItem('jwt');
        },
        clickMenuIcon() {
            if (this.menuOpen) {
                this.menuHeight = this.$refs.logo.offsetHeight;
            } else {
                this.menuHeight = this.$refs.logo.offsetHeight + this.$refs.menu.$el.scrollHeight;
            }

            this.menuOpen = !this.menuOpen;
        },
    },
};
</script>

<template lang='pug'>
    .h-full.flex.flex-wrap

        aside.bg-secondary.w-full.md_w-3-12.xl_w-2-12.md_min-h-screen.overflow-hidden(v-if='$store.state.jwt')
            .px-1_5(
                :style='{ height: ["xs", "sm", "md"].includes($mq) ? `${menuHeight}px` : "auto" }',
            )
                .flex.items-center.py-_5.md_py-1_5(ref='logo')
                    .w-2-12.mdi.text-3xl.text-secondary-200.md_hidden(
                        :class='menuOpen ? "mdi-close" : "mdi-menu"',
                        @click='clickMenuIcon',
                    )
                    svg.h-2.lg_h-3.w-8-12.md_w-full(
                        xmlns='http://www.w3.org/2000/svg',
                        viewBox='0 0 365.5 102.2',
                    )
                        path.fill-current.text-white(d='M261.5 102.2c2.4-5.7 4.6-11 6.8-16.3.3-.8.3-1.8 0-2.6-3.9-10-7.9-20.1-11.8-30.1-.4-1.2-.9-1.7-2.2-1.6-1.9.1-3.7 0-5.9 0v35.2h-13.8V51.6H228V41.1h6.5V25.9h13.8V41h14c4.3 0 4.3 0 5.7 4.1l7.2 20.7c.1.4.3.8.7 1.6 2.3-7 4.5-13.6 6.7-20.1.7-2.1.9-4.9 2.4-6 1.4-1 4.1-.3 6.3-.3h8.1c-1.2 3.2-2.3 6.2-3.5 9.2-6.3 16.7-12.6 33.3-18.9 50-.5 1.4-1.1 2-2.7 1.9-4.1 0-8.3.1-12.8.1z')
                        path.fill-current.text-primary(d='M153.4 86.7v-4.4c-7 8.9-21.2 6.9-28.1 1.2-11.5-9.5-11.8-31.3 1.7-40.1 5.5-3.6 11.5-4.8 18-3.2 3.3.8 6 2.6 8.3 5.7v-4.7H167v45.5h-13.6zM142 75.6c6.5 0 11.4-5 11.4-11.7 0-6.6-5-11.6-11.5-11.6-6.4 0-11.4 5.1-11.4 11.8.1 6.5 5.2 11.5 11.5 11.5z')
                        path.fill-current.text-white(d='M365.1 68.2H331c.6 6.5 7.1 9 11.5 8.5 2.6-.3 4.7-1.4 6.4-3.3.4-.4 1.1-.9 1.6-.9 4-.1 7.9 0 11.9 0 .4 0 .8.1 1.2.1C361 81.1 350.3 90.7 337 88c-13.9-2.8-21.2-15.3-19.7-26.8C319.2 46.9 332 37.3 346 40c12.9 2.4 21.5 15 19.1 28.2zm-13.6-9.5c-.8-4.5-5.2-7.6-10.4-7.5-5 .1-9.1 3.2-9.8 7.5h20.2z')
                        path.fill-current.text-primary(d='M23.9 40.2l15.9 15c.5.5.8 1.4 1.1 2.1 2 6 4.1 12 5.7 16.8 5-17.4 10.3-35.8 15.6-54.5 5.5 2 10.8 3.9 16.4 5.8 2-5 3.9-9.8 5.9-14.9-5-2.4-9.8-5-14.6-7.5 0-.1.1-.3.1-.4C78 5 86 7.4 94.3 9.9c-3.7 8.5-7.3 16.9-11.1 25.4-3.9-1.1-7.7-2.1-11.7-3.2-.3.8-.5 1.5-.8 2.2-5.6 17-11.2 33.9-16.7 50.8-.5 1.5-1.2 1.9-2.7 1.9-3.3-.1-6.6 0-9.8-.1-.6 0-1.6-.5-1.8-1C34.3 70.8 29 55.6 23.6 40.5l.3-.3z')
                        path.fill-current.text-white(d='M191.6 73.2c4.4 0 8.6 0 12.7.1.5 0 1.2.7 1.4 1.2 1.3 3.6 6.9 3.4 8.7 1.5 1.3-1.4 1.3-3.3-.3-4.6-1.2-.9-2.6-1.6-4-2.1-2.6-1-5.2-1.9-7.9-2.9-.7-.3-1.5-.6-2.2-.9-10.8-5-9.1-16-2.8-21.4 7.5-6.4 20.4-5.9 26.9 1.1 2 2.2 3 4.6 3.6 8.9h-12.8c-.3 0-.7-.6-.9-1-1.2-2.4-4.8-3.1-6.8-1.4-1.5 1.3-1.5 3.3.4 4.4 2 1.2 4.3 2 6.6 2.8 2.6 1 5.3 1.7 7.9 2.8 8.8 3.8 8.7 14.1 4.7 19.5-4.7 6.4-11.5 7.9-18.9 7.2-4.5-.4-8.7-2-11.9-5.5-2.7-2.7-3.8-5.9-4.4-9.7zM39.8 49c-.9-.8-1.3-1.2-1.8-1.6-4.6-4.3-9.3-8.5-13.9-12.8-1-.9-1.8-1.1-3-.7-3.3 1-6.5 1.9-10.1 2.8-3.6-8.3-7.2-16.5-11-24.9.9-.4 1.7-.8 2.5-1.2C9.8 7.4 17 4.2 24.3 1.1c1.5-.6 3.2-.9 4.8-1 3.3-.2 6.6 0 10 0 .8 5.1 2.6 9.6 8.6 10 4.2.3 7.5-2.6 9.5-7.8 1.1 5.3-2.6 11.1-7.8 13-6.8 2.5-13.6.2-16.5-5.8-3-.3-5.8 0-8.5 1.4-4 2-8.3 3.7-12.5 5.6 1.1 2.9 2.2 5.7 3.4 8.4.2.4 1.3.8 1.8.7 4.3-1.1 8.7-2.3 13-3.6 1.5-.4 2.1-.3 2.5 1.3 2.2 8 4.5 16 6.8 24 .2.4.2.8.4 1.7z')
                        path.fill-current.text-primary(d='M172.9 26h13.4v60.8h-13.4V26z')
                        path.fill-current.text-white(d='M313.8 86.8h-13.5V25.9h13.5v60.9z')
                        path.fill-current.text-primary(d='M93.1 86.8V41.2h12.8v4c2.9-4.1 6.8-5.6 11.7-5.6 0 4.4 0 8.7-.1 12.9 0 .3-.8.8-1.2.9-1.2.2-2.4.2-3.6.5-4 .8-5.9 3.1-5.9 7.1-.1 7.8 0 15.7 0 23.5v2.3H93.1zM87.5 86.9H75.3c-.4 0-.8 0-1.3-.1V41.3h13.5v45.6z')


                b-menu.md_mt-1.menu.pb-_5.md_pb-1_5(
                    ref='menu',
                    :activable='false',
                )
                    b-menu-list(label='Menu')
                        b-menu-item(
                            icon='account-group-outline',
                            label='Customers',
                            tag='router-link',
                            to='/admin/customers/1',
                            :class='{ "router-link-exact-active": ["customer", "customers"].includes($route.name) }',
                        )
                        b-menu-item(
                            icon='receipt',
                            label='Invoices',
                            tag='router-link',
                            to='/admin/invoices/1',
                            :class='{ "router-link-exact-active": ["invoice", "invoices"].includes($route.name) }',
                        )
                        b-menu-item(
                            icon='cart-outline',
                            label='Orders',
                            tag='router-link',
                            to='/admin/orders/1',
                            :class='{ "router-link-exact-active": ["order", "orders", "order-details", "order-printer-jobs"].includes($route.name) }',
                        )
                        b-menu-item(
                            icon='tshirt-crew-outline',
                            label='Products',
                            tag='router-link',
                            :to='{ name: "products", params: { page: "1" } }',
                            :class='{ "router-link-exact-active": ["products", "product-create", "product-edit"].includes($route.name) }',
                        )
                        b-menu-item(
                            icon='printer',
                            label='Printers',
                            tag='router-link',
                            :to='{ name: "printers", params: { page: "1" } }',
                            :class='{ "router-link-exact-active": ["printers", "printer", "printer-edit", "printer-product-edit"].includes($route.name) }',
                        )
                        b-menu-item(
                            icon='tray-full',
                            label='Printer Jobs',
                            tag='router-link',
                            to='/admin/printer-jobs/1',
                            :class='{ "router-link-exact-active": ["printer-jobs", "printer-job"].includes($route.name) }',
                        )
                        b-menu-item(
                            icon='wrench-outline',
                            label='Rule Builder',
                            tag='router-link',
                            to='/admin/rules/1',
                            :class='{ "router-link-exact-active": ["rule-create", "rule-edit"].includes($route.name) }',
                        )
                    b-menu-list(label='Actions')
                        b-menu-item(
                            icon='logout',
                            label='Sign Out',
                            @click='logout',
                        )

        .min-h-full.w-full.md_w-9-12.xl_w-10-12

            .bg-white.dark-mode_bg-secondary.w-full.flex.items-center.border-b.border-gray-300.md_border-l.dark-mode_border-secondary-1000.border-t.md_border-t-0

                .text-xl.dark-mode_text-secondary-600.capitalize.px-1_5.py-_5.md_p-1.border-r.dark-mode_border-secondary-1000.border-gray-300
                    span(v-if='["order-details", "order", "order-printer-jobs"].includes($route.name)') Order
                    span(v-else) {{ $route.name ? $route.name.replaceAll('-', ' ') : '' }}

                .flex.flex-wrap.text-secondary-600.text-sm.px-1

                    template(v-if='["customer"].includes($route.name)')
                        router-link(to='/admin/customers/1') CUSTOMERS
                        span &nbsp;&nbsp;/&nbsp;&nbsp;
                        span.dark-mode_text-secondary-200 CUSTOMER # {{ $route.params.id }}

                    template(v-if='["invoice"].includes($route.name)')
                        router-link(to='/admin/invoices/1') INVOICES
                        span &nbsp;&nbsp;/&nbsp;&nbsp;
                        span.dark-mode_text-secondary-200 INVOICE # {{ $route.params.id }}

                    template(v-if='["order-details", "order", "order-printer-jobs"].includes($route.name)')
                        router-link(to='/admin/orders/1') ORDERS
                        span &nbsp;&nbsp;/&nbsp;&nbsp;
                        span.dark-mode_text-secondary-200 ORDER # {{ $route.params.id }}

                    template(v-else-if='$route.name === "rule-edit"')
                        router-link(to='/admin/rules/1') RULES
                        span &nbsp;&nbsp;/&nbsp;&nbsp;
                        span.dark-mode_text-secondary-200 RULE # {{ $route.params.id }}

                    template(v-else-if='$route.name === "rule-create"')
                        router-link(to='/admin/rules/1') RULES
                        span &nbsp;&nbsp;/&nbsp;&nbsp;
                        span.dark-mode_text-secondary-200 CREATE RULE

                    template(v-else-if='$route.name === "product-edit"')
                        router-link(to='/admin/products/1') PRODUCTS
                        span &nbsp;&nbsp;/&nbsp;&nbsp;
                        span.text-secondary-200 PRODUCT # {{ $route.params.id }}

                    template(v-else-if='$route.name === "product-create"')
                        router-link(to='/admin/products/1') PRODUCTS
                        span &nbsp;&nbsp;/&nbsp;&nbsp;
                        span.dark-mode_text-secondary-200 CREATE PRODUCT

                    template(v-else-if='["printer", "printer-edit", "printer-product-edit"].includes($route.name)')
                        router-link(to='/admin/printers/1') PRINTERS
                        span &nbsp;&nbsp;/&nbsp;&nbsp;
                        template(v-if='$route.name === "printer-product-edit"')
                            router-link(:to='`/admin/printer/${$route.params.printerId}`') PRINTER # {{ $route.params.printerId }}
                            span &nbsp;&nbsp;/&nbsp;&nbsp;
                            span.dark-mode_text-secondary-200 PRODUCT # {{ $route.params.id }}
                        span.dark-mode_text-secondary-200(v-else) PRINTER # {{ $route.params.id }}

                    template(v-else-if='["printer-job"].includes($route.name)')
                        router-link(to='/admin/printer-jobs/1') PRINTER JOBS
                        span &nbsp;&nbsp;/&nbsp;&nbsp;
                        span.dark-mode_text-secondary-200 PRINTER JOB # {{ $route.params.id }}

            router-view(v-if='$store.state.user')

        transition(name='account')
            account(v-if='!$store.state.jwt')
</template>

<style lang='scss'>
body,
html {
  min-height: 100%;
  @apply bg-gray-100;
}

aside > div {
  transition: height 200ms;
}

.b-table .table td.is-sticky.col.bg-gray-200 {
  @apply bg-gray-200;
}

.menu-list a {
  @apply text-secondary-200;
}

.help {
  @apply mb-_25;
}

.b-radio.radio .control-label {
  @apply pl-_5;
}

.b-radio.radio:not(.button) {
  @apply mr-1;
}

.b-table .table {
  @apply border-none;

  th {

    &.is-current-sort,
    &.is-sortable:hover {
      @apply border-primary;
    }
  }

  td {
    @apply border-dashed;
  }
}

.menu-list a.router-link-exact-active,
.menu-list a:hover,
.menu-list li.router-link-exact-active a {
  @apply bg-secondary-100 text-secondary-800;
}

.select:not(.is-multiple):not(.is-loading):hover::after {
  @apply border-primary;
}

.detail-container {
  @apply relative;
}

.account-enter-active,
.account-leave-active {
  transition: all 250ms ease-out; // hack to make transitions work the way we are using it...

  .account-left,
  .account-right {
    transition: transform 250ms ease-out;
  }
}

.account-enter,
.account-leave-to {
  .account-left {
    transform: translateX(-100%);
  }

  .account-right {
    transform: translateX(100%);
  }
}

.account-enter-to,
.account-leave {
  .account-left {
    transform: translateX(0);
  }

  .account-right {
    transform: translateX(0);
  }
}

.field.is-floating-in-label .control.is-loading::after,
.field.is-floating-in-label > :not(.datepicker):not(.timepicker):not(.taginput) .select:not(multiple).is-loading::after {
  margin-top: 0;
}

.b-tabs .tab-content {
  padding: 0;
}

.b-tabs .tabs {
  @apply rounded-t;
}

// .b-table .table th .th-wrap.is-numeric {
//   flex-direction: unset;
//   text-align: right;
// }

.table .is-invisible {
  display: none;
}

.b-checkbox .control-label {
  display: none;
}

.color {
  &--selected {
    @apply shadow-xl border-primary-900;
  }
}

.masonry-fix {
  margin: 1rem 1.5rem !important;
}

@media (min-width: 768px) {
  .b-table .table {
    @apply border border-gray-300;
  }
}

@media (prefers-color-scheme: dark) {

  body,
  html {
    @apply bg-secondary-1100;
  }

  a:active,
  a:hover {
    @apply text-primary-900;
  }

  .input,
  .select select,
  .textarea {
    @apply bg-secondary text-white border-secondary-800 border-2;

    &:disabled {
      @apply bg-secondary-700 border-secondary-700;

      &:hover {
        @apply border-secondary-700;
      }
    }
  }

  .select select option {
    @apply text-white;
  }

  .select.is-empty select {
    @apply text-secondary-500;
  }

  .b-table .table {
    @apply bg-secondary border-none;

    th {
      @apply border-secondary;

      &.is-current-sort,
      &.is-sortable:hover {
        @apply border-primary;
      }
    }

    td {
      @apply border-secondary-800 border-dashed;
    }
  }

  .label {
    @apply text-secondary-200;
  }

  .b-table .table,
  .control-label,
  .pagination-link,
  .pagination-link:hover {
    @apply text-secondary-200;
  }

  .b-radio.radio input[type=radio] + .check,
  .pagination-link:hover {
    @apply border-secondary-200;
  }

  .pagination-link,
  .pagination-link[disabled] {
    @apply bg-secondary border-secondary;
  }

  .b-table .table thead th,
  .menu-label,
  .tabs a {
    @apply text-secondary-600;
  }

  .b-table .table td.is-sticky.col.bg-gray-200 {
    @apply bg-secondary-900;
  }

  .b-table .table tr.detail,
  .b-tabs .tabs,
  .table.is-striped tbody tr:not(.is-selected):nth-child(even) {
    @apply bg-secondary-900 shadow-none;
  }

  .tabs {

    a,
    ul {
      @apply border-secondary-800;
    }

    a:hover {
      @apply text-secondary-500 border-secondary-500
    }
  }

  @media(max-width: 768px) {

    .b-table .table-wrapper.has-mobile-cards tr:not([class*=is-]),
    .b-table .table-wrapper.has-mobile-cards tr:not([class*=is-]):hover {
      @apply bg-secondary;
    }

    .b-table .table-wrapper.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td {
      @apply border-secondary-800 border-dashed;
    }
  }
}
</style>
